import { render, staticRenderFns } from "./o12.vue?vue&type=template&id=c3f88bb8&scoped=true"
import script from "./o12.vue?vue&type=script&lang=js"
export * from "./o12.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3f88bb8",
  null
  
)

export default component.exports